module.exports = __webpack_public_path__ + "img/VP-Profi13_Overview-Spare_1.f38bd457.jpg";